import { LiquidVolume } from "../rna-cish/RnaCatalog";
// A representation of a kit received from the server.
// Doesn't have certain extras needed to support the editing UI, but should be a good fit for a r/o view.
// As in the backend, probe sets need more post processing to turn into something consumable, while we can get away
// with simpler types for amplifier and buffers.
var BundleOfKits = /** @class */ (function () {
    function BundleOfKits(sampleType, protocolType, kits, comment) {
        this.sampleType = sampleType;
        this.protocolType = protocolType;
        this.kits = kits;
        this.comment = comment;
    }
    return BundleOfKits;
}());
export { BundleOfKits };
var IndividualKits = /** @class */ (function () {
    function IndividualKits(config, channel, probeSetComponents, amplifierComponents, buffersComponents, chromogenComponents) {
        this.config = config;
        this.channel = channel;
        this.probeSetComponents = probeSetComponents;
        this.amplifierComponents = amplifierComponents;
        this.buffersComponents = buffersComponents;
        this.chromogenComponents = chromogenComponents;
    }
    return IndividualKits;
}());
export { IndividualKits };
var RnaFishKit = /** @class */ (function () {
    function RnaFishKit(comment, legacy, sampleType, probeSetComponent, amplifierComponent, buffersComponent) {
        this.probeSetComponent = probeSetComponent;
        this.amplifierComponent = amplifierComponent;
        this.buffersComponent = buffersComponent;
        this.legacy = legacy;
        this.sampleType = sampleType;
        this.comment = comment;
    }
    return RnaFishKit;
}());
export { RnaFishKit };
var SimpleProbeSetComponent = /** @class */ (function () {
    function SimpleProbeSetComponent(probeSet, scale, index) {
        this.probeSet = probeSet;
        this.scale = scale;
        this.index = index;
    }
    return SimpleProbeSetComponent;
}());
export { SimpleProbeSetComponent };
var SimpleCatalogVariantProbeSet = /** @class */ (function () {
    function SimpleCatalogVariantProbeSet(customerOrganismName, customerTargetName, customerAccessionNum, customerSequence, customerProbeSetSize, organism, probeSetFamily, variant, hcrAmplifier, probeLotNumber) {
        this.customerOrganismName = customerOrganismName;
        this.customerTargetName = customerTargetName;
        this.customerAccessionNum = customerAccessionNum;
        this.customerSequence = customerSequence;
        this.customerProbeSetSize = customerProbeSetSize;
        this.organism = organism;
        this.probeSetFamily = probeSetFamily;
        this.variant = variant;
        this.hcrAmplifier = hcrAmplifier;
        this.probeLotNumber = probeLotNumber;
    }
    return SimpleCatalogVariantProbeSet;
}());
export { SimpleCatalogVariantProbeSet };
var SimpleLibraryOrganismCustomTargetProbeSet = /** @class */ (function () {
    function SimpleLibraryOrganismCustomTargetProbeSet(organism, target, hcrAmplifier, probeSetSize, probeLotNumber) {
        this.organism = organism;
        this.target = target;
        this.hcrAmplifier = hcrAmplifier;
        this.probeSetSize = probeSetSize;
        this.probeLotNumber = probeLotNumber;
    }
    return SimpleLibraryOrganismCustomTargetProbeSet;
}());
export { SimpleLibraryOrganismCustomTargetProbeSet };
var SimpleOtherOrganismCustomTargetProbeSet = /** @class */ (function () {
    function SimpleOtherOrganismCustomTargetProbeSet(organism, target, hcrAmplifier, probeSetSize, probeLotNumber) {
        this.organism = organism;
        this.target = target;
        this.hcrAmplifier = hcrAmplifier;
        this.probeSetSize = probeSetSize;
        this.probeLotNumber = probeLotNumber;
    }
    return SimpleOtherOrganismCustomTargetProbeSet;
}());
export { SimpleOtherOrganismCustomTargetProbeSet };
var RnaFishAmplifierComponent = /** @class */ (function () {
    function RnaFishAmplifierComponent(hcrAmplifier, scale, label, index) {
        this.hcrAmplifier = hcrAmplifier;
        this.scale = scale;
        this.label = label;
        this.index = index;
    }
    return RnaFishAmplifierComponent;
}());
export { RnaFishAmplifierComponent };
var RnaFishBuffersComponent = /** @class */ (function () {
    function RnaFishBuffersComponent(amp, hybridization, wash, goldWash, goldAmpWash, proAmpWash, index) {
        this.amp = amp;
        this.hybridization = hybridization;
        this.wash = wash;
        this.goldWash = goldWash;
        this.goldAmpWash = goldAmpWash;
        this.proAmpWash = proAmpWash;
        this.index = index;
    }
    return RnaFishBuffersComponent;
}());
export { RnaFishBuffersComponent };
// Amplifier parts
var FreeTextAmpLabel = /** @class */ (function () {
    function FreeTextAmpLabel(name) {
        this.name = "";
        this.name = name;
    }
    return FreeTextAmpLabel;
}());
export { FreeTextAmpLabel };
// 2-IHC
// tslint:disable-next-line:max-classes-per-file
var Ihc2Kit = /** @class */ (function () {
    function Ihc2Kit(comment, legacy, sampleType, probe, amplifier, buffers) {
        this.sampleType = sampleType;
        this.probeComponent = probe;
        this.amplifierComponent = amplifier;
        this.buffersComponent = buffers;
        this.comment = comment;
        this.legacy = legacy;
    }
    return Ihc2Kit;
}());
export { Ihc2Kit };
// tslint:disable-next-line:max-classes-per-file
var Ihc2ProbeComponent = /** @class */ (function () {
    function Ihc2ProbeComponent(probe, amplifier, scale, index) {
        this.probe = probe;
        this.amplifier = amplifier;
        this.scale = scale;
        this.index = index;
    }
    return Ihc2ProbeComponent;
}());
export { Ihc2ProbeComponent };
// tslint:disable-next-line:max-classes-per-file
var Ihc2BuffersComponent = /** @class */ (function () {
    function Ihc2BuffersComponent(antibodyBuffer, amplificationBuffer, goldAmpWashBuffer, index) {
        this.antibodyBuffer = antibodyBuffer;
        this.amplificationBuffer = amplificationBuffer;
        this.goldAmpWashBuffer = goldAmpWashBuffer;
        this.index = index;
    }
    return Ihc2BuffersComponent;
}());
export { Ihc2BuffersComponent };
// tslint:disable-next-line:max-classes-per-file
var BundleOfKitsPrice = /** @class */ (function () {
    function BundleOfKitsPrice(individualKitPrices, subtotalCents) {
        this.individualKitPrices = individualKitPrices;
        this.subtotalCents = subtotalCents;
    }
    return BundleOfKitsPrice;
}());
export { BundleOfKitsPrice };
// tslint:disable-next-line:max-classes-per-file
var IndividualKitPrice = /** @class */ (function () {
    function IndividualKitPrice(channel, probeSetPrices, amplifierPrices, buffersPrices, chromogenPrices) {
        this.channel = channel;
        this.probeSetPrices = probeSetPrices;
        this.amplifierPrices = amplifierPrices;
        this.buffersPrices = buffersPrices;
        this.chromogenPrices = chromogenPrices;
    }
    return IndividualKitPrice;
}());
export { IndividualKitPrice };
// tslint:disable-next-line:max-classes-per-file
var ComponentPriceInfo = /** @class */ (function () {
    function ComponentPriceInfo(priceCents, priceCustom, index) {
        this.priceCents = priceCents;
        this.priceCustom = priceCustom;
        this.index = index;
    }
    return ComponentPriceInfo;
}());
export { ComponentPriceInfo };
// tslint:disable-next-line:max-classes-per-file
var RnaFishKitPrice = /** @class */ (function () {
    function RnaFishKitPrice(probeSetPriceCents, probeSetPriceCustom, amplifierPriceCents, amplifierPriceCustom, buffersPriceCents, buffersPriceCustom, subtotalCents) {
        this.probeSetPriceCents = probeSetPriceCents;
        this.probeSetPriceCustom = probeSetPriceCustom;
        this.amplifierPriceCents = amplifierPriceCents;
        this.amplifierPriceCustom = amplifierPriceCustom;
        this.buffersPriceCents = buffersPriceCents;
        this.buffersPriceCustom = buffersPriceCustom;
        this.subtotalCents = subtotalCents;
    }
    return RnaFishKitPrice;
}());
export { RnaFishKitPrice };
// tslint:disable-next-line:max-classes-per-file
var Ihc2KitPrice = /** @class */ (function () {
    function Ihc2KitPrice(probePriceCents, amplifierPriceCents, buffersPriceCents, subtotalCents) {
        this.probePriceCents = probePriceCents;
        this.amplifierPriceCents = amplifierPriceCents;
        this.buffersPriceCents = buffersPriceCents;
        this.subtotalCents = subtotalCents;
    }
    return Ihc2KitPrice;
}());
export { Ihc2KitPrice };
// tslint:disable-next-line:max-classes-per-file
var PricedBundleOfKits = /** @class */ (function () {
    function PricedBundleOfKits(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return PricedBundleOfKits;
}());
export { PricedBundleOfKits };
// tslint:disable-next-line:max-classes-per-file
var RnaFishPricedKit = /** @class */ (function () {
    function RnaFishPricedKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return RnaFishPricedKit;
}());
export { RnaFishPricedKit };
// tslint:disable-next-line:max-classes-per-file
var Ihc2PricedKit = /** @class */ (function () {
    function Ihc2PricedKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return Ihc2PricedKit;
}());
export { Ihc2PricedKit };
// tslint:disable-next-line:max-classes-per-file
var RnaCishKit = /** @class */ (function () {
    function RnaCishKit(comment, reasonForOther, protocolType, config, probeSetComponent, amplifierComponent, bufferComponent, miscComponent, chromogenComponent, probeKitCatalogNumber, probeACatalogNumber, probeBCatalogNumber, probeDiluentACatalogNumber, probeDiluentBCatalogNumber, pretreatCatalogNumber, postProcessACatalogNumber, postProcessBCatalogNumber, pretreatACatalogNumber, pretreatBCatalogNumber, pretreatCCatalogNumber) {
        this.comment = comment;
        this.reasonForOther = reasonForOther;
        this.protocolType = protocolType;
        this.config = config;
        this.probeSetComponent = probeSetComponent;
        this.amplifierComponent = amplifierComponent;
        this.bufferComponent = bufferComponent;
        this.miscComponent = miscComponent;
        this.chromogenComponent = chromogenComponent;
        this.probeKitCatalogNumber = probeKitCatalogNumber;
        this.probeACatalogNumber = probeACatalogNumber;
        this.probeBCatalogNumber = probeBCatalogNumber;
        this.probeDiluentACatalogNumber = probeDiluentACatalogNumber;
        this.probeDiluentBCatalogNumber = probeDiluentBCatalogNumber;
        this.pretreatCatalogNumber = pretreatCatalogNumber;
        this.postProcessACatalogNumber = postProcessACatalogNumber;
        this.postProcessBCatalogNumber = postProcessBCatalogNumber;
        this.pretreatACatalogNumber = pretreatACatalogNumber;
        this.pretreatBCatalogNumber = pretreatBCatalogNumber;
        this.pretreatCCatalogNumber = pretreatCCatalogNumber;
    }
    return RnaCishKit;
}());
export { RnaCishKit };
// tslint:disable-next-line:max-classes-per-file
var RnaCishProbeSetComponent = /** @class */ (function () {
    function RnaCishProbeSetComponent(protocolType, probeSet, scale, probeHybridizationAScale, probeHybridizationBScale, index) {
        this.protocolType = protocolType;
        this.probeSet = probeSet;
        this.scale = scale;
        this.probeHybridizationAScale = probeHybridizationAScale;
        this.probeHybridizationBScale = probeHybridizationBScale;
        this.index = index;
    }
    return RnaCishProbeSetComponent;
}());
export { RnaCishProbeSetComponent };
// tslint:disable-next-line:max-classes-per-file
var RnaCishCatalogVariantRefProbeSet = /** @class */ (function () {
    function RnaCishCatalogVariantRefProbeSet(customerOrganismName, customerTargetName, customerAccessionNum, customerSequence, customerProbeSetSize, organism, probeSetFamily, variant, hcrAmplifier, probeLotNumber) {
        this.customerOrganismName = customerOrganismName;
        this.customerTargetName = customerTargetName;
        this.customerAccessionNum = customerAccessionNum;
        this.customerSequence = customerSequence;
        this.customerProbeSetSize = customerProbeSetSize;
        this.organism = organism;
        this.probeSetFamily = probeSetFamily;
        this.variant = variant;
        this.hcrAmplifier = hcrAmplifier;
        this.probeLotNumber = probeLotNumber;
    }
    return RnaCishCatalogVariantRefProbeSet;
}());
export { RnaCishCatalogVariantRefProbeSet };
// tslint:disable-next-line:max-classes-per-file
var RnaCishLibraryOrganismCustomTargetProbeSet = /** @class */ (function () {
    function RnaCishLibraryOrganismCustomTargetProbeSet(organism, target, hcrAmplifier, probeSetSize, probeLotNumber) {
        this.organism = organism;
        this.target = target;
        this.hcrAmplifier = hcrAmplifier;
        this.probeSetSize = probeSetSize;
        this.probeLotNumber = probeLotNumber;
    }
    return RnaCishLibraryOrganismCustomTargetProbeSet;
}());
export { RnaCishLibraryOrganismCustomTargetProbeSet };
// tslint:disable-next-line:max-classes-per-file
var RnaCishOtherOrganismCustomTargetProbeSet = /** @class */ (function () {
    function RnaCishOtherOrganismCustomTargetProbeSet(organism, target, hcrAmplifier, probeSetSize, probeLotNumber) {
        this.organism = organism;
        this.target = target;
        this.hcrAmplifier = hcrAmplifier;
        this.probeSetSize = probeSetSize;
        this.probeLotNumber = probeLotNumber;
    }
    return RnaCishOtherOrganismCustomTargetProbeSet;
}());
export { RnaCishOtherOrganismCustomTargetProbeSet };
// tslint:disable-next-line:max-classes-per-file
var RnaCishAmplifierComponent = /** @class */ (function () {
    function RnaCishAmplifierComponent(hcrAmplifier, hapten, antiHapten1, tyramideHapten, amplifierScale, antiHapten1Scale, tyramideHaptenScale, antiHapten2ApScale, antiHapten2HrpScale, antiHapten2Ap, antiHapten2Hrp, prefilled, index) {
        this.hcrAmplifier = hcrAmplifier;
        this.hapten = hapten;
        this.antiHapten1 = antiHapten1;
        this.tyramideHapten = tyramideHapten;
        this.antiHapten2Ap = antiHapten2Ap;
        this.antiHapten2Hrp = antiHapten2Hrp;
        this.amplifierScale = amplifierScale;
        this.antiHapten1Scale = antiHapten1Scale;
        this.tyramideHaptenScale = tyramideHaptenScale;
        this.antiHapten2ApScale = antiHapten2ApScale;
        this.antiHapten2HrpScale = antiHapten2HrpScale;
        this.prefilled = prefilled;
        this.index = index;
    }
    return RnaCishAmplifierComponent;
}());
export { RnaCishAmplifierComponent };
// tslint:disable-next-line:max-classes-per-file
var RnaCishLeicaBuffersComponent = /** @class */ (function () {
    function RnaCishLeicaBuffersComponent(sampleType, amplificationBufferScale, blockingSolutionScale, endogenousEnzymeScale, preHybridizationScale, hrpQuencherScale, bluingAgentScale, index) {
        this.sampleType = sampleType;
        this.amplificationBufferScale = amplificationBufferScale;
        this.blockingSolutionScale = blockingSolutionScale;
        this.endogenousEnzymeScale = endogenousEnzymeScale;
        this.preHybridizationScale = preHybridizationScale;
        this.hrpQuencherScale = hrpQuencherScale;
        this.bluingAgentScale = bluingAgentScale;
        this.index = index;
    }
    return RnaCishLeicaBuffersComponent;
}());
export { RnaCishLeicaBuffersComponent };
// tslint:disable-next-line:max-classes-per-file
var RnaCishOncoreProXBuffersComponent = /** @class */ (function () {
    function RnaCishOncoreProXBuffersComponent(sampleType, amplificationBufferScale, blockingSolutionScale, endogenousEnzymeScale, preHybridizationScale, hrpQuencherScale, bluingAgentScale, index) {
        this.sampleType = sampleType;
        this.amplificationBufferScale = amplificationBufferScale;
        this.blockingSolutionScale = blockingSolutionScale;
        this.endogenousEnzymeScale = endogenousEnzymeScale;
        this.preHybridizationScale = preHybridizationScale;
        this.hrpQuencherScale = hrpQuencherScale;
        this.bluingAgentScale = bluingAgentScale;
        this.index = index;
    }
    return RnaCishOncoreProXBuffersComponent;
}());
export { RnaCishOncoreProXBuffersComponent };
// tslint:disable-next-line:max-classes-per-file
var RnaCishRocheBuffersComponent = /** @class */ (function () {
    function RnaCishRocheBuffersComponent(sampleType, amplificationBufferScale, blockingSolutionScale, endogenousEnzymeBufferScale, preHybridizationScale, antigenRetrievalScale, dewaxScale, index) {
        this.sampleType = sampleType;
        this.amplificationBufferScale = amplificationBufferScale;
        this.blockingSolutionScale = blockingSolutionScale;
        this.endogenousEnzymeScale = endogenousEnzymeBufferScale;
        this.preHybridizationScale = preHybridizationScale;
        this.antigenRetrievalScale = antigenRetrievalScale;
        this.dewaxScale = dewaxScale;
        this.index = index;
    }
    return RnaCishRocheBuffersComponent;
}());
export { RnaCishRocheBuffersComponent };
// tslint:disable-next-line:max-classes-per-file
var RnaCishManualBuffersComponent = /** @class */ (function () {
    function RnaCishManualBuffersComponent(sampleType, amplificationBufferScale, blockingSolutionScale, endogenousEnzymeScale, preHybridizationScale, hrpQuencherScale, bluingAgentScale, index) {
        this.sampleType = sampleType;
        this.amplificationBufferScale = amplificationBufferScale;
        this.blockingSolutionScale = blockingSolutionScale;
        this.endogenousEnzymeScale = endogenousEnzymeScale;
        this.preHybridizationScale = preHybridizationScale;
        this.hrpQuencherScale = hrpQuencherScale;
        this.bluingAgentScale = bluingAgentScale;
        this.index = index;
    }
    return RnaCishManualBuffersComponent;
}());
export { RnaCishManualBuffersComponent };
// tslint:disable-next-line:max-classes-per-file
var RnaCishMiscComponent = /** @class */ (function () {
    function RnaCishMiscComponent(description, scaleInMl, scaleInSlides) {
        this.description = description;
        this.scaleInMl = new LiquidVolume(scaleInMl);
        this.scaleInSlides = scaleInSlides;
    }
    return RnaCishMiscComponent;
}());
export { RnaCishMiscComponent };
// tslint:disable-next-line:max-classes-per-file
var RnaCishChromogenComponent = /** @class */ (function () {
    function RnaCishChromogenComponent(chromogenScale, chromogenBufferScale, hematoxylinScale, index, chromogen, chromogenBuffer) {
        this.chromogen = chromogen;
        this.chromogenBuffer = chromogenBuffer;
        this.chromogenScale = chromogenScale;
        this.chromogenBufferScale = chromogenBufferScale;
        this.hematoxylinScale = hematoxylinScale;
        this.index = index;
    }
    return RnaCishChromogenComponent;
}());
export { RnaCishChromogenComponent };
// tslint:disable-next-line:max-classes-per-file
var SimpleLibraryOrganism = /** @class */ (function () {
    function SimpleLibraryOrganism(id, name, scientificName) {
        this.id = id;
        this.name = name;
        this.scientificName = scientificName;
    }
    SimpleLibraryOrganism.prototype.displayName = function () {
        return this.name + " " + (this.scientificName.trim().length > 0 ? '(' + this.scientificName.trim() + ')' : '');
    };
    return SimpleLibraryOrganism;
}());
export { SimpleLibraryOrganism };
// tslint:disable-next-line:max-classes-per-file
var SimpleProbeSetFamily = /** @class */ (function () {
    function SimpleProbeSetFamily(id, geneSymbol, description, accessions) {
        this.id = id;
        this.geneSymbol = geneSymbol;
        this.description = description;
        this.accessions = accessions;
    }
    SimpleProbeSetFamily.prototype.displayName = function () {
        return this.geneSymbol + " " + (this.description.trim().length > 0 ? '(' + this.description.trim() + ')' : '');
    };
    return SimpleProbeSetFamily;
}());
export { SimpleProbeSetFamily };
// tslint:disable-next-line:max-classes-per-file
var SimpleOtherOrganism = /** @class */ (function () {
    function SimpleOtherOrganism(name) {
        this.name = name;
    }
    return SimpleOtherOrganism;
}());
export { SimpleOtherOrganism };
// tslint:disable-next-line:max-classes-per-file
var SimpleAccession = /** @class */ (function () {
    function SimpleAccession(id, accessionNum) {
        this.id = id;
        this.accessionNum = accessionNum;
    }
    return SimpleAccession;
}());
export { SimpleAccession };
// tslint:disable-next-line:max-classes-per-file
var SimpleVariant = /** @class */ (function () {
    function SimpleVariant(id, name, designNumber, targetMrnaSeq, probeSetSize, dcvScore, accession) {
        this.id = id;
        this.name = name;
        this.designNumber = designNumber;
        this.probeSetSize = probeSetSize;
        this.targetMrnaSeq = targetMrnaSeq;
        this.dcvScore = dcvScore;
        this.accession = accession;
    }
    return SimpleVariant;
}());
export { SimpleVariant };
// tslint:disable-next-line:max-classes-per-file
var CustomTarget = /** @class */ (function () {
    function CustomTarget(name, accession, targetMrnaSeq) {
        this.name = name;
        this.accession = accession;
        this.targetMrnaSeq = targetMrnaSeq;
    }
    return CustomTarget;
}());
export { CustomTarget };
// tslint:disable-next-line:max-classes-per-file
var RnaCishPricedKit = /** @class */ (function () {
    function RnaCishPricedKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return RnaCishPricedKit;
}());
export { RnaCishPricedKit };
// tslint:disable-next-line:max-classes-per-file
var RnaCishKitPrice = /** @class */ (function () {
    function RnaCishKitPrice(probeSetPriceCents, probeSetPriceCustom, amplifierPriceCents, amplifierPriceCustom, buffersPriceCents, buffersPriceCustom, miscComponentPriceCents, miscComponentPriceCustom, chromogenPriceCents, chromogenPriceCustom, subtotalCents) {
        this.probeSetPriceCents = probeSetPriceCents;
        this.probeSetPriceCustom = probeSetPriceCustom;
        this.amplifierPriceCents = amplifierPriceCents;
        this.amplifierPriceCustom = amplifierPriceCustom;
        this.buffersPriceCents = buffersPriceCents;
        this.buffersPriceCustom = buffersPriceCustom;
        this.miscComponentPriceCents = miscComponentPriceCents;
        this.miscComponentPriceCustom = miscComponentPriceCustom;
        this.chromogenPriceCents = chromogenPriceCents;
        this.chromogenPriceCustom = chromogenPriceCustom;
        this.subtotalCents = subtotalCents;
    }
    return RnaCishKitPrice;
}());
export { RnaCishKitPrice };
//# sourceMappingURL=KitModel.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/KitModel.js
// module id = 21
// module chunks = 0